import React, {Component} from "react";
import {PopoverBody, UncontrolledPopover} from "reactstrap";

class BatchTrade extends Component {
    render() {
        const {handleChange, checked} = this.props;

        return <div className="d-flex align-items-center mb-2">
            <input checked={checked} type="checkbox" style={{margin: "0 0.25rem 0.5rem 0"}}
                   onChange={(e) => handleChange(e.target.checked)}/>
            <label id={"batch_trade"} style={{textDecoration: "underline"}}>
                Batch Trade
            </label>
            <UncontrolledPopover trigger="hover focus" target="batch_trade" fade placement="top"
                                 style={{zIndex: 1000}}>
                <PopoverBody className={"py-3"}>
                     <span className="text-left ">When selected, trades across multiple clients will be batched together and executed as a single order.
                    This results in each client receiving the same execution price. When Batch Trade is not selected, each
                    client will be traded on an individual basis and will likely be executed at different prices.</span>
                </PopoverBody>
            </UncontrolledPopover>

        </div>;
    }
}

export default BatchTrade;
